import * as React from 'react';

import {
  Colors,
} from '@bluecurrent/web-component-lib';

export default function Spacing() {
  return (
    <div
      style={{
        width: '100%',
        height: 'calc(100% - 56px)',
        borderBottom: `solid 4px ${Colors.MEDIUM_GREY}`,
        borderRight: `dashed 4px ${Colors.MEDIUM_WHITE}`,
        position: 'relative',
      }}
    >
      <div
        style={{
          height: 56,
          width: '100%',
          position: 'absolute',
          bottom: -56,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          left: 4,
          zIndex: 1,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div
            style={{
              height: 14,
              minWidth: 0,
              borderLeft: `solid 4px ${Colors.MEDIUM_GREY}`,
            }}
          />
          <div
            style={{
              height: 25,
              minWidth: 0,
              borderLeft: `dashed 4px ${Colors.MEDIUM_WHITE}`,
            }}
          />
        </div>
      </div>
    </div>
  );
}
